import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from 'app/core/utils/http-utils';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'app/core/config/application-config.service';
import { Page } from '../../shared/model/page.model';
import { IExtratoEfd } from 'app/shared/model/extrato-efd.model';

interface QueryParams {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ExtratoProcessamentoEfdService {

    resourceUrl = this.applicationConfigService.getEndpointFor('/sfz-obrigacoes-acessorias-api/api');

    constructor(
      protected http: HttpClient,
      protected applicationConfigService: ApplicationConfigService
    ) {}

    query(req?: QueryParams): Observable<Page<IExtratoEfd>> {
      const mappedParams = this.mapearParametrosConsulta(req);
      const params = HttpUtils.buildHttpParams(mappedParams);
      return this.http.get<Page<IExtratoEfd>>(this.resourceUrl + '/extratos', { params });
    }

    private mapearParametrosConsulta(req?: QueryParams): { [key: string]: any } {
      const mappedParams: { [key: string]: any } = {};

      if (!req) {
        return mappedParams;
      }

      this.adicionarCompetenciaSePresente(mappedParams, 'competenciaInicial', req['competenciaInicial']);
      this.adicionarCompetenciaSePresente(mappedParams, 'competenciaFinal', req['competenciaFinal']);
      this.adicionarSePresente(mappedParams, 'page', req['page']);
      this.adicionarSePresente(mappedParams, 'size', req['size']);
      this.adicionarSePresente(mappedParams, 'sort', req['sort']);
      this.adicionarSePresente(mappedParams, 'indicadorSituacao', req['indicadorSituacao']);

      return mappedParams;
    }

    private adicionarSePresente(mappedParams: { [key: string]: any }, chave: string, valor: any): void {
      if (valor !== undefined && valor !== null && valor !== '') {
        mappedParams[chave] = valor;
      }
    }

    private adicionarCompetenciaSePresente(mappedParams: { [key: string]: any }, chave: string, valor: any): void {
      if (valor !== undefined && valor !== null && valor !== '') {
        const competencia = String(valor);
        mappedParams[chave] = `${competencia.substring(4)}/${competencia.substring(0, 4)}`;
      }
    }
}
